import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilizadoresService {

  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(`/Utilizador`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/Utilizador/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  update(data: any): Observable<any> {
    return this.apiService.put(
      `/Utilizador`, data
    ).pipe(
      map(response => response)
    );
  }

  toggleStatus(id: string): Observable<any> {
    return this.apiService.patch(
      `/Utilizador/${id}`, {}
    ).pipe(
      map(response => response)
    );
  }

  getInforByNIF(numeroDocumento: string, utilizadorId: string): Observable<any> {
    return this.apiService
      .get(`/Nif/${numeroDocumento}/${utilizadorId}`)
      .pipe(
        map(response => response)
      );
  }

  getRoles(): Observable<any> {
    return this.apiService.get(`/Utilizador/Role`,
    ).pipe(
      map(response => response)
    );
  }

  addRoleToUser(params: any): Observable<any> {
    return this.apiService.post(`/Utilizador/Role/AddRoleUser`, params
    ).pipe(
      map(response => response)
    );
  }

  deleteRoleByUserId(params: any): Observable<any> {
    return this.apiService.delete(`/Utilizador/Role/DeleteRoleUser`, params
    ).pipe(
      map(response => response)
    );
  }

  getRoleByUserId(userId: string): Observable<any> {
    return this.apiService.get(`/Utilizador/Role/${userId}`,
    ).pipe(
      map(response => response)
    );
  }

  checkPerfilUser(userID: string): Observable<any> {
    return this.apiService.get(`/Utilizador/VerificarPerfil/${userID}`,
    ).pipe(
      map(response => response)
    );
  }

}